import { createSlice } from "@reduxjs/toolkit";
import { LocationType } from "../models/LocationType/LocationType";

const LocationTypeInitialState: {
	locationTypes: LocationType[];
} = {
	locationTypes: [],
};

export const LocationTypesReducer = createSlice({
	name: "__",
	initialState: LocationTypeInitialState,
	reducers: {
		setLocationTypes(state, { payload }) {
			state.locationTypes = payload;
		},
	},
});
